export * from './lib/components/search-page/search-page.component';
